var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-switch',{staticClass:"specific-switch",attrs:{"rounded":_vm.isRounded,"outlined":_vm.isOutlined,"size":_vm.size,"aria-labelledby":_vm.switchLabel},on:{"input":_vm.toggleSwitch}},[_vm._v(_vm._s(_vm.switchLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }